import {
    LuCalculator,
    LuChartBar,
    LuClipboardList,
    LuCreditCard,
    LuFileSearch,
    LuFileText,
    LuFileUp,
    LuHandshake,
    LuHeart,
    LuMail,
    LuMessageCircle,
    LuReceipt,
    LuRecycle,
    LuUsers,
} from 'react-icons/lu';

import { TaskType } from '@ndvr/customer-api';

import { CalendarIcon } from '@/components/Icons';

interface TaskTypeIconProps {
    type?: string;
}

const className = 'min-h-4 h-4 w-4 min-w-4 mr-1';

export const TaskTypeIcon = (props: TaskTypeIconProps) => {
    switch (props.type) {
        case TaskType.ACCOUNT_CHANGE:
            return <LuRecycle className={className} />;
        case TaskType.ACCOUNT_DEPOSIT:
            return <LuFileUp className={className} />;
        case TaskType.ACCOUNT_WITHDRAWAL:
            return <LuCreditCard className={className} />;
        case TaskType.RMD:
            return <LuCalculator className={className} />;
        case TaskType.CHARITABLE_GIFT:
            return <LuHeart className={className} />;
        case TaskType.CLIENT_ONBOARDING:
            return <LuUsers className={className} />;
        case TaskType.TRADE_REQUEST:
            return <LuChartBar className={className} />;
        case TaskType.FINANCIAL_PLAN:
            return <LuFileSearch className={className} />;
        case TaskType.BACKDOOR_ROTH_CONTRIBUTION:
            return <LuFileUp className={className} />;
        case TaskType.CORRESPONDENCE:
            return <LuMail className={className} />;
        case TaskType.REPORTING:
            return <LuClipboardList className={className} />;
        case TaskType.TAX_PLANNING:
            return <LuReceipt className={className} />;
        case TaskType.PLANNING_OPPORTUNITY:
            return <LuFileText className={className} />;
        case TaskType.CLIENT_COMMUNICATION:
            return <LuMessageCircle className={className} />;
        case TaskType.COORDINATION:
            return <LuHandshake className={className} />;
        default:
            return <CalendarIcon className={className} />;
    }
};
